import { render, staticRenderFns } from "./BannersManager.html?vue&type=template&id=07d07135&scoped=true&"
import script from "./BannersManager.js?vue&type=script&lang=js&"
export * from "./BannersManager.js?vue&type=script&lang=js&"
import style0 from "./BannersManager.scss?vue&type=style&index=0&id=07d07135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d07135",
  null
  
)

export default component.exports